import React from "react";
import HeroCTR from "../../components/hero/HeroSectionComp";
import InfoCTR from "../../containers/home/InfoCTR"
import AllPackages from "../../containers/home/AllPackagesCTR";
import FAQAccordion from "../../components/service/ServiceFaq";
import ContactUsCTR from "../services/ContactusCTR";
import { Link } from "react-router-dom";

function ServiceCTR() {
  const faqs = [
    {
      question: "What services does Bonvoy Tourism offer?",
      answer:
        "Bonvoy Tourism offers 17 UAE tour services across six categories: Desert Safaris (morning, afternoon, evening, VIP, private car, ATV quad combo), Adventure Tours (dune buggy rides, quad biking), Dubai City Tours (half-day and full-day private), Dhow Cruise Dinner Experiences (Dubai Marina and Dubai Creek), UAE Day Trips from Dubai (Abu Dhabi, Al Ain, Hatta, Sharjah, Ajman, 6 Emirates), and Combo & Private Group Tours. All services include hotel pickup, a licensed guide, a DTA-insured vehicle, and complimentary travel insurance.",
      image: "/images/destination/detail/d11.jpg",
    },
    {
      question: "Do all Bonvoy Tourism services include hotel pickup from Dubai?",
      answer:
        "Yes — hotel pickup and drop-off from any hotel, residence, Dubai Airport (Terminal 1, 2 or 3), or Dubai Cruise Terminal (Port Rashid) is included as standard across all 17 tours and services. There is no need to arrange your own transport. Your licensed driver meets you at your hotel lobby at the confirmed time, and drops you back when your tour ends.",
      image: "/images/destination/detail/d12.jpg",
    },
    {
      question: "Which Bonvoy Tourism service is best for a short layover or one-day visit to Dubai?",
      answer:
        "For a short layover or single-day visit, we recommend the Dubai Half Day City Tour (4–5 hours, from AED 350/person) or the Afternoon Desert Safari with BBQ Dinner (6 hours, from AED 85/person). If you want to experience both the city and the desert on the same day, our Dubai City Tour + Desert Safari 2-in-1 Combo fits everything into a single day with a hotel break between the two experiences. All three tours can typically be booked with same-day or next-day availability.",
      image: "/images/destination/detail/d21.jpg",
    },
    {
      question: "Can Bonvoy Tourism arrange private group tours?",
      answer:
        "Yes — all Bonvoy Tourism services can be arranged as fully private experiences for any group size, from couples and families to corporate groups of 100+. Private tours come with a dedicated vehicle (or multiple vehicles for larger groups), a guide exclusively for your group, and complete flexibility over timing and itinerary. Contact us on +971-55-9215470 via WhatsApp to discuss your private group requirements.",
      image: "/images/destination/detail/d22.jpg",
    },
    {
      question: "Does Bonvoy Tourism offer services outside Dubai?",
      answer:
        "Yes. While all tours depart from Dubai with complimentary hotel pickup, our day trip services cover the wider UAE. Destinations include Abu Dhabi (Sheikh Zayed Grand Mosque, Louvre, Qasr Al Watan, Emirates Palace), Al Ain (UNESCO World Heritage Oasis, Jebel Hafeet, Camel Market, hot springs), Hatta (mountain dam, Heritage Village, Wadi Hub), Sharjah and Ajman (combined 2-in-1 tour), and a 6 Emirates in a Day tour covering five additional emirates beyond Dubai. No passport or UAE visa extensions are required for any of these destinations.",
      image: "/images/destination/detail/d31.jpg",
    },
    {
      question: "What adventure services does Bonvoy Tourism offer in Dubai?",
      answer:
        "Bonvoy Tourism's adventure services include: Dune Buggy Rides on the Lahbab Red Dunes (Can-Am Maverick or Polaris RZR, 1000cc), available in 30-minute, 1-hour, and 2-hour sessions with solo, 2-seater and 4-seater options; ATV Quad Bike Combo paired with a full evening desert safari, BBQ dinner and live entertainment; and Afternoon Red Dune Bashing Only, for guests who want the pure dune driving experience without the camp. All adventure tours include a safety briefing, full safety gear, a professional guide, and hotel pickup.",
      image: "/images/destination/detail/d32.jpg",
    },
    {
      question: "How do I book a Bonvoy Tourism service?",
      answer:
        "You can book directly at bonvoytourism.com/tour — browse our 17 experiences, select your date and group size, and complete your secure online booking. We accept AED, USD, EUR and CHF. You receive instant confirmation by email and WhatsApp with your driver's contact details and hotel pickup instructions. Our team is also available 24/7 on +971-55-9215470 via phone or WhatsApp to help you choose the right service and complete your booking in minutes.",
      image: "/images/destination/detail/d41.jpg",
    },
  ];
  const iconProps = {
    width: 28,
    height: 28,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#ff9219",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  const includedServicesData = [
    {
      icon: (
        <svg {...iconProps}>
          <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
      title: "Hotel Pickup & Drop-Off",
      description:
        "From any Dubai hotel, residence, airport or cruise terminal — no taxis, no coordination.",
    },
    {
      icon: (
        <svg {...iconProps}>
          <path d="M3 13l1.5-4.5A2 2 0 016.4 7h11.2a2 2 0 011.9 1.5L21 13m-18 0v5a1 1 0 001 1h1a1 1 0 001-1v-1h12v1a1 1 0 001 1h1a1 1 0 001-1v-5m-18 0h18M6 16.5h.01M18 16.5h.01" />
        </svg>
      ),
      title: "Licensed & Insured Vehicle",
      description:
        "Every vehicle is DTA-licensed, regularly maintained, fully air-conditioned and insured.",
    },
    {
      icon: (
        <svg {...iconProps}>
          <circle cx="12" cy="8" r="4" />
          <path d="M4 21v-1a7 7 0 0114 0v1" />
        </svg>
      ),
      title: "Expert Licensed Guide",
      description:
        "Long-term Dubai residents who know the city and desert inside out — and love sharing it.",
    },
    {
      icon: (
        <svg {...iconProps}>
          <path d="M12 2l8 3v6c0 5-3.5 8.5-8 11-4.5-2.5-8-6-8-11V5l8-3z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      ),
      title: "Free Travel Insurance",
      description:
        "Complimentary travel insurance for every participant on every booking, automatically.",
    },
    {
      icon: (
        <svg {...iconProps}>
          <rect x="2" y="5" width="20" height="14" rx="2" />
          <path d="M2 10h20M6 15h4" />
        </svg>
      ),
      title: "Best Price Guarantee",
      description:
        "Find the same tour cheaper online — we match it immediately, no questions asked.",
    },
    {
      icon: (
        <svg {...iconProps}>
          <circle cx="12" cy="12" r="9" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      ),
      title: "Free Cancellation",
      description:
        "Cancel up to 24 hours before departure for a full refund. No conditions, no fees.",
    },
    {
      icon: (
        <svg {...iconProps}>
          <path d="M12 2l2.5 6.5L21 9l-5 4.5L17.5 21 12 17l-5.5 4L8 13.5 3 9l6.5-.5L12 2z" />
        </svg>
      ),
      title: "Zero Hidden Charges",
      description:
        "The price you see is the price you pay. All inclusions are clearly listed on every tour page.",
    },
    {
      icon: (
        <svg {...iconProps}>
          <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
        </svg>
      ),
      title: "24/7 WhatsApp Support",
      description:
        "A real person available at +971-55-9215470 around the clock — before, during, and after your tour.",
    },
  ];
  return (
    <div>
      <HeroCTR
        img="/images/hero/bg-subheader.jpg"
        heading="Our Dubai Tour Services"
        para="17 UAE Experiences · Desert, City, Cruise & Adventure · Hotel Pickup Included"
      />

      <div className="mt-12 md:mt-22">
        {/* Section 1 */}
        <div className="flex flex-col md:flex-row gap-4 md:gap-22 items-center justify-between">
          <div
            className="md:flex-1 w-full h-[318px] md:h-[418px] bg-cover bg-top rounded-md"
            style={{ backgroundImage: "url('/images/services/s1.jpg')" }}
          ></div>
          <div className="flex-1">
            <h3 className="text-[20px] md:text-[24px] lg:text-[30px] text-[#666] font-semibold mb-2">
              Dubai's Best Tours & UAE Experiences — All in One Place
            </h3>
            <p className="text-[15px] text-[#8C8C8C] max-w-[730px] mb-4">
              At Bonvoy Tourism, we design every journey around you. Whether you are arriving in Dubai for a single afternoon or spending two weeks exploring the UAE — we have the right experience for your time, your budget, and your sense of adventure. From the iconic Lahbab Red Dunes to the ancient UNESCO heritage sites of Al Ain and the illuminated skyline of Dubai Marina at night — every experience we offer has been personally crafted to give you the very best the UAE has to give.
            </p>
            <p className="text-[13px] text-[#606060] max-w-[730px]">
              Our dedicated team handles every detail — from hotel pickup in your air-conditioned vehicle to the exact sunset photography stop your guide knows will give you the best shot. You focus on the experience. We take care of everything else. That is the Bonvoy Tourism promise.
            </p>
          </div>
        </div>

        <div className="mb-[48px]">
          <InfoCTR />
        </div>

        <div className="-mx-6 sm:-mx-10 md:-mx-14 lg:-mx-20">
          <AllPackages />
        </div>

        {/* Section 6: Included With Every Service */}
        <div className="mt-[48px] mb-[48px]">
          <h2 className="text-[20px] md:text-[24px] lg:text-[30px] text-[#666] font-semibold mb-2">
            Included With Every Bonvoy Tourism Service — No Exceptions
          </h2>
          <p className="text-[15px] text-[#8C8C8C] max-w-[730px] mb-8">
            Not add-ons. Not upgrades. Every single Bonvoy Tourism booking includes all of the following automatically:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {includedServicesData.map((item, index) => (
              <div key={index} className="shadow-md rounded-md p-5 bg-[#f9f9f9]">
                <div className="h-full">
                  <div className="flex flex-col justify-between h-full min-h-[200px]">
                    <div className="flex items-center">
                      <div className="bg-white p-3 shadow-md rounded-md">
                        {item.icon}
                      </div>
                    </div>
                    <div>
                      <p className="text-[15px] font-semibold text-[#4E4E4E] max-w-[730px] mb-2">
                        {item.title}
                      </p>
                      <p className="text-[13px] font-medium text-[#606060] max-w-[730px]">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Section 2 */}
        <div className="flex flex-col-reverse md:flex-row gap-4 md:gap-22 items-center justify-between mt-[48px]">
          <div className="flex-1">
            <h3 className="text-[20px] md:text-[24px] lg:text-[30px] text-[#666] font-semibold mb-2">
              Why Bonvoy Tourism — Dubai's Most Trusted Tour Operator
            </h3>
            <p className="text-[15px] text-[#8C8C8C] max-w-[730px] mb-4">
              We have built Bonvoy Tourism from the ground up on a single principle: every guest deserves a genuinely outstanding experience. Not a packaged, standardised tour where you are one of a hundred guests on a bus — but a thoughtful, personal experience led by someone who actually loves what they do and genuinely knows this city inside out.
            </p>
            <p className="text-[13px] text-[#606060] max-w-[730px]">
              Our guides Rashid and Taj are not hired for the season — they are the heart of the company. They are mentioned by name across dozens of five-star TripAdvisor reviews. They know which dune catches the best light at sunset. They know the quietest corner of the Gold Souk. They know which photo will make your friends ask 'where did you go?' They bring that knowledge and that passion to every single tour.
            </p>
            <p className="text-[13px] text-[#606060] max-w-[730px] mb-5">
              With a perfect 5.0 rating on TripAdvisor across 60+ verified reviews, a top 9% ranking among all outdoor providers in Dubai, and thousands of guests who return or refer us to friends — Bonvoy Tourism is not just a tour operator. We are the tour operator Dubai visitors trust most.
            </p>
            <Link
              to="/tour"
              className="bg-[#ff9219] text-white mt-[8px] py-2 px-3 rounded-[4px] font-medium hover:bg-slate-400 transition-all duration-300 ease-in-out"
            >
              Browse All Tours
            </Link>
          </div>
          <div
            className="md:flex-1 w-full h-[318px] md:h-[418px] bg-cover bg-top rounded-md"
            style={{ backgroundImage: "url('/images/services/s2.jpg')" }}
          ></div>
        </div>
        <div className="flex-1">
          <FAQAccordion data={faqs} />
        </div>
        <ContactUsCTR />
      </div>

    </div>
  );
}

export default ServiceCTR;
